goog.require('el8.service.urls');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.urls = {};

el8.main.urls.init = function(spec) {
    for (var key in spec) {
        if (spec.hasOwnProperty(key) && spec[key]) {
            el8.service.urls.add(key, spec[key]);
        }
    }
};
